import { ReactNode } from "react";
import { motion } from "framer-motion";

import { t } from "@lingui/macro";
import { AspectRatio } from "@reactive-resume/ui";
import { useResumeStore } from "@/client/stores/resume";
import { cn, templatesList } from "@reactive-resume/utils";

import { SectionIcon } from "../shared/section-icon";
import { CollapsibleSection } from "../../CollapsibleSection";

export const TemplateSection = () => {
  const setValue = useResumeStore((state) => state.setValue);
  const currentTemplate = useResumeStore((state) => state.resume.data.metadata.template);

  const headerHTML: ReactNode = (
    <div className="flex items-center gap-x-4">
      <SectionIcon id="template" size={18} name={t`Template`} />
      <span className="line-clamp-1 text-base font-bold lg:text-lg">{t`Template`}</span>
    </div>
  );

  const contentHTML: ReactNode = (
    <div className="max-h-[450px] overflow-y-auto rounded-md bg-[#E3E3E380] p-3">
      <main className="grid grid-cols-2 gap-8 @lg/right:grid-cols-3 @2xl/right:grid-cols-4">
        {templatesList.map((template, index) => (
          <AspectRatio key={template} ratio={1 / 1.4142}>
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1, transition: { delay: index * 0.1 } }}
              whileTap={{ scale: 0.98, transition: { duration: 0.1 } }}
              className={cn(
                "relative cursor-pointer rounded-sm ring-primary transition-all hover:ring-2",
                currentTemplate === template && "ring-2",
              )}
              onClick={() => {
                setValue("metadata.template", template);
              }}
            >
              <img src={`/templates/jpg/${template}.jpg`} alt={template} className="rounded-sm" />

              <div className="absolute inset-x-0 bottom-0 h-32 w-full bg-gradient-to-b from-transparent to-background/80">
                <p className="absolute inset-x-0 bottom-2 text-center font-bold capitalize text-primary">
                  {template}
                </p>
              </div>
            </motion.div>
          </AspectRatio>
        ))}
      </main>
    </div>
  );

  return (
    <CollapsibleSection
      id="template"
      header={headerHTML}
      defaultOpen={true}
      content={contentHTML}
    />
  );
};
